// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"12d0a445","239":"03a7b4a1","455":"fa54569e"}[chunkId] + ".chunk.js";
};